import React from 'react';

const CostTable = ({ item, isView, vendorCosts, updateCost, vendors }) => {
  return (
    <div>
      <span className="label-text font-weight-bold">Product Cost Per Unit</span>
      <table className="card-table">
        <thead>
          <tr>
            <th>Tier</th>
            {vendors.map(v => (
              <th key={v.key} className={`text-center ${v.key}-header`}>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  {v.flagImg && <img src={v.flagImg} alt="" style={{ width: 14, height: 10 }} />}
                  {v.label.toUpperCase()}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {item.tiers.map((tier, tIdx) => (
            <tr key={tier.id}>
              <td className="tier-cell">
                <span className="font-weight-bold">Tier {tIdx + 1}</span>
                <span className="text-muted" style={{ fontSize: 10 }}>
                  ({tier.quantity} units)
                </span>
              </td>
              {vendors.map(v => (
                <td key={v.key} className="input-cell">
                  <div className="currency-input-wrapper">
                    <span>$</span>
                    <input
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      disabled={isView}
                      value={vendorCosts[item.id]?.[v.key]?.[tier.id] || ''}
                      onChange={e => updateCost(item.id, v.key, tier.id, e.target.value)}
                    />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CostTable;
